import { useState, useEffect, useCallback } from "react";
import "./MarkAllAsRead.css";
import { useSelector } from "react-redux";
import { ref, onValue } from "firebase/database";
import { database } from "../../firebase"; 
import axios from "axios";

const API_BASE = "https://estbn.com/EstbnNew/public/api/portal";
const newBaseUrl = "https://estbn.com/EstbnNew/public";

const PAGE_CONFIG = {
  orders: {
    type: "orders",
    apiKey: "unread_orders_count",
    firebaseKey: "orders_count",
  },
  maintenance: {
    type: "price_plan_request",
    apiKey: "unread_price_plan_request_count",
    firebaseKey: "price_plan_requests_count",
  },
  requests: {
    type: "other_request",
    apiKey: "unread_other_request_count",
    firebaseKey: "other_requests_count",
  },
  helpRequests: {
    type: "help",
    apiKey: "unread_help_count",
    firebaseKey: "help_requests_count",
  },
  sosRequests: {
    type: "sos",
    apiKey: "unread_count",
    firebaseKey: "sos_count",
  },
};

export default function MarkAllAsRead({ page, onSuccess }) {
  const { user } = useSelector((state) => state.auth);
  const token = user?.token;
  const config = PAGE_CONFIG[page];

  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    if (!token || !config) return;

    axios
      .get(`${newBaseUrl}/api/portal/unread-count`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setCount(res.data?.[config.apiKey] ?? 0);
      })
      .catch((err) => {
        console.error("MarkAllAsRead - fetch unread count failed:", err);
        setCount(0);
      });
  }, [token, config]);

  useEffect(() => {
    if (!token || !config) return;

    const unreadRef = ref(database, "unread_count");
    const unsubscribe = onValue(unreadRef, (snapshot) => {
      if (!snapshot.exists()) return;
      const data = snapshot.val();
      const newValue = data?.[config.firebaseKey];
      if (typeof newValue === "number") {
        setCount(newValue);
      }
    });

    return () => unsubscribe();
  }, [token, config]);

  const showToast = useCallback((message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  }, []);

  const handleMarkAllAsRead = async () => {
    if (!config) {
      console.error(`MarkAllAsRead: unknown page "${page}"`);
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/mark-all-as-read`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ type: config.type }),
      });

      if (!res.ok) throw new Error("Request failed");

      setCount(0);
      showToast('All Marked As Read Successfully', "success");
      onSuccess?.();
    } catch (err) {
      console.error("Mark all as read failed:", err);
      showToast("An error occurred, please try again", "error");
    } finally {
      setLoading(false);
    }
  };

  const isDisabled = loading || count === null || count === 0;

  return (
    <div className="mar-wrapper">
      <button
        className="mar-btn"
        disabled={isDisabled}
        onClick={handleMarkAllAsRead}
      >
        {loading ? "..." : "Mark all as read"}
      </button>

      {toast && (
        <div className={`mar-toast mar-toast-${toast.type}`}>
          {toast.message}
        </div>
      )}
    </div>
  );
}
